import axios from "axios";

function base64UrlDecode(value) {
  let normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  while (normalized.length % 4) {
    normalized += "=";
  }
  return atob(normalized);
}

function decodeJwtExpiryMs(token) {
  try {
    const payload = JSON.parse(base64UrlDecode(token.split(".")[1]));
    return payload.exp ? payload.exp * 1000 : null;
  } catch (e) {
    return null;
  }
}

// LoginResponse/RefreshTokenResponse'dan gelen tokenleri sakla; exp claim'i ve refreshExpiresIn
// burada bir kere hesaplanip localStorage'a yazilir, istek basina tekrar decode edilmez.
export function storeAuthTokens(response) {
  localStorage.setItem("AUTH_TOKEN", response.accessToken);
  axios.defaults.headers.common["Authorization"] = response.accessToken;

  if (response.refreshToken) {
    localStorage.setItem("REFRESH_TOKEN", response.refreshToken);
  }

  const accessExpiresAt = decodeJwtExpiryMs(response.accessToken);
  if (accessExpiresAt) {
    localStorage.setItem("ACCESS_EXPIRES_AT", String(accessExpiresAt));
  }

  if (response.refreshExpiresIn) {
    localStorage.setItem("REFRESH_EXPIRES_AT", String(Date.now() + response.refreshExpiresIn * 1000));
  }
}

export function clearAuthTokens() {
  localStorage.removeItem("AUTH_TOKEN");
  localStorage.removeItem("REFRESH_TOKEN");
  localStorage.removeItem("ACCESS_EXPIRES_AT");
  localStorage.removeItem("REFRESH_EXPIRES_AT");
  delete axios.defaults.headers.common["Authorization"];
}
